// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"954":"ac8932f6","1216":"4527af1e","2040":"40b775d8","3168":"40b775d8","8241":"ac8932f6","9864":"e78279b3","9900":"02c43525"}[chunkId] + ".chunk.css";
};